const postalCodePatterns: Record<string, RegExp> = {
    US: /^\d{5}(?:-\d{4})?$/,
};

export const normalizePostalCode = (value: string, countryAbbreviation?: string) => {
    const country = countryAbbreviation?.toUpperCase();
    if (country === "GB" || country === "IE") {
        return value.toUpperCase();
    }

    const digits = value.replace(/\D/g, "");
    return digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
};

const validators = {
    postalCode: (value: string, countryAbbreviation?: string) => {
        const country = countryAbbreviation?.toUpperCase();
        if (country === "GB" || country === "IE") {
            return normalizePostalCode(value, country).trim().length > 0;
        }

        const pattern = postalCodePatterns.US;
        return pattern.test(normalizePostalCode(value, country).trim());
    },
    name: (value: string) => /^[A-Za-z][A-Za-z'\-\s’]*$/.test(value),
    city: (value: string) => /^[A-Za-z’'-][A-Za-z\s’'-]*$/.test(value),
    company: (value: string) => /^(?![ &])[a-zA-Z0-9\s\-+'&’]+$/.test(value),
    street: (value: string) => /^[a-zA-Z0-9 ,.\-'’]*$/.test(value),
};

export default validators;
